<div class="main-wrapper-section">
    <div class="common-header">
        <h3><span class="clickable" [routerLink]="['/mem-contact', contactId]" target="_blank">{{ accountName }}</span> Membership</h3>
    </div>
    <div class="card-section">
        <div class="card-panel">
            <form [formGroup]="membershipForm">
                <div class="field-form-panel">
                    <label style="font-weight: bold; font-size: 18px;">
                        Primary Member: <span [routerLink]="['/mem-contact', contactId]" target="_blank" class="clickable">{{ membershipForm.get('primaryName')?.value }}</span>
                        <span style="padding-left: 10px; color: black;">(Member for {{membershipForm.get('memberForMonths')?.value}} months)</span>
                    </label>
                    <div class="flex-form contracts-flex-form">
                        <div class="form-group">
                            <label>Account Status</label>
                            <select class="form-control" formControlName="accountStatus">
                                <option value="0">--Select--</option>
                                <option *ngFor="let item of ref_MemAccountStatus" value="{{item.statusID}}">{{item.status}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Subscription Type</label>
                            <select class="form-control" formControlName="subscriptionType">
                                <option value="0">--Select--</option>
                                <option *ngFor="let item of ref_MemSubscriptionType" value="{{item.subTypeID}}">{{item.subType}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Site</label>
                            <select class="form-control" formControlName="siteId">
                                <option value="0">--Select--</option>
                                <option *ngFor="let item of ref_MemLocation" value="{{item.locationID}}">{{item.location}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Membership Company</label>
                            <select class="form-control" formControlName="membershipCompany">
                                <option value="0">--Select--</option>
                                <option *ngFor="let item of ref_MemCompany" value="{{item.companyID}}">{{item.company}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="flex-form contracts-flex-form">
                        <div class="form-group">
                            <label>Membership Start Date</label>
                            <mat-form-field>
                                <input matInput #ref [matDatepicker]="memStartDate" class="form-control" formControlName="memStartDate" id="memStartDate">
                                <mat-datepicker-toggle matSuffix [for]="memStartDate"></mat-datepicker-toggle>
                                <mat-datepicker #memStartDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <label>Total Account Reservations</label>
                            <input class="form-control" type="number" formControlName="totAccountReservations" />
                        </div>
                        <div class="form-group">
                            <label>Last 12 Months Reservations</label>
                            <input class="form-control" type="number" formControlName="last12MonthsReservations" />
                        </div>
                        <div class="form-group">
                            <label>Reservation Status</label>
                            <select class="form-control" formControlName="resNetStatus">
                                <option value="0">--Select--</option>
                                <option *ngFor="let item of ref_MemResNetStatus" value="{{item.statusID}}">{{item.status}}</option>
                            </select>
                        </div>
                    </div>
                    <hr style="padding:10px 0px;" />
                    <h5>Members</h5>
                    <div style="margin:10px 0px;">
                        <div class="table-panel">
                            <div class="table-body">
                                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>
                                    <ng-container *ngFor="let column of columns" [matColumnDef]="column.field">
                                        <ng-container>
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ column.title }} </th>
                                            <td mat-cell *matCellDef="let dataItem; let rowIndex = index">
                                                <div class="memcon-name" *ngIf="column.field == 'name'">
                                                    <a href="javascript:void();" (click)="gotoLink($event, 'memContact', dataItem);">{{dataItem['firstName']}} {{dataItem['lastName']}}</a>
                                                </div>
                                                <div class="memcon-email" *ngIf="column.field == 'email'"><a href="javascript:void();" (click)="gotoLink($event, 'email', dataItem);">{{ dataItem[column.field] }}</a></div>
                                                <div class="memcon-mobile" *ngIf="column.field == 'mobile'"><a href="javascript:void();" (click)="gotoLink($event, 'mobile', dataItem);">{{ dataItem[column.field] | phoneFormat}}</a></div>
                                                <div class="memcon-mobile text-center" *ngIf="column.field == 'cmContractID'">
                                                    <a (click)="gotoLink($event, 'cmContract', dataItem);">
                                                        <img src="../../../../assets/icon_contact.svg" />
                                                    </a>
                                                </div>
                                                <div class="memcon-mobile" *ngIf="column.field == 'memberStatus'">{{ dataItem[column.field]}} </div>
                                                <div class="memcon-mobile" *ngIf="column.field == 'membershipID'"><a href="javascript:void();" (click)="gotoLink($event, 'memMemberShip', dataItem);">{{ dataItem.membershipAccountName}}</a> </div>
                                                <!--<div class="memcon-mobile" *ngIf="column.field == 'subscriptionID'">
                                                    <a (click)="gotoLink($event, 'memSubscription', dataItem);" href="javascript:void();">
                                                        {{ dataItem[column.field]}}
                                                    </a>
                                                </div>-->
                                                <div class="memcon-mobile" *ngIf="column.field == 'onboardedByCLPUser'">{{ dataItem[column.field]}} </div>
                                                <div class="memcon-mobile" *ngIf="column.field == 'dateOfLastReservation'">{{ dataItem[column.field] | date:dateFormat}} </div>
                                            </td>
                                        </ng-container>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="memContactListDisplayColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: memContactListDisplayColumns;"
                                        [class.selected]="selectedRow === row"></tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <hr style="padding:10px 0px;" />
                    <h5>Subscription</h5>
                    <div style="margin:10px 0px;">
                        <div class="table-panel subscription-table">
                            <div class="table-body">
                                <table mat-table [dataSource]="dataSourceSub" class="mat-elevation-z8" matSort>
                                    <ng-container *ngFor="let column of columnsSub" [matColumnDef]="column.field">
                                        <ng-container>
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ column.title }} </th>
                                            <td mat-cell *matCellDef="let dataItem; let rowIndex = index">
                                                <div class="memcon-name" *ngIf="column.field == 'subscription'">{{dataItem?.subscription}}</div>
                                                <div class="memcon-email" *ngIf="column.field == 'vSubscriptionID'">{{dataItem?.vSubscriptionID }}</div>
                                                <div class="memcon-mobile" *ngIf="column.field == 'totalAmount'">{{dataItem?.totalAmount}}</div>
                                                <div class="memcon-mobile" *ngIf="column.field == 'dtNextBill'">{{dataItem?.dtNextBill | date:dateFormat}} </div>
                                            </td>
                                        </ng-container>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="memSubDisplayColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: memSubDisplayColumns;"
                                        [class.selected]="selectedRow === row"></tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <hr style="padding:10px 0px;" />
                    <h5>Sales</h5>
                    <div class="flex-form contracts-flex-form">
                        <div class="form-group">
                            <label>Sales Closed Date</label>
                            <mat-form-field>
                                <input matInput #ref [matDatepicker]="salesCloseDate" class="form-control" formControlName="salesCloseDate" id="salesCloseDate">
                                <mat-datepicker-toggle matSuffix [for]="salesCloseDate"></mat-datepicker-toggle>
                                <mat-datepicker #salesCloseDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <label>Current A/R Date</label>
                            <mat-form-field>
                                <input matInput #ref [matDatepicker]="currAprDate" class="form-control" formControlName="currAprDate" id="currAprDate">
                                <mat-datepicker-toggle matSuffix [for]="currAprDate"></mat-datepicker-toggle>
                                <mat-datepicker #currAprDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <label>Days A/R</label>
                            <input class="form-control" formControlName="daysAR" />
                        </div>
                    </div>
                    <div class="flex-form contracts-flex-form">
                        <div class="form-group">
                            <label>Prepaid Monthly Amount</label>
                            <input class="form-control" formControlName="prePaidMonthlyAmount" />
                        </div>
                        <div class="form-group">
                            <label>Prepaid Monthly Payment Through Date</label>
                            <mat-form-field>
                                <input matInput #ref [matDatepicker]="payThroughDate" class="form-control" formControlName="payThroughDate" id="payThroughDate">
                                <mat-datepicker-toggle matSuffix [for]="payThroughDate"></mat-datepicker-toggle>
                                <mat-datepicker #payThroughDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <hr style="padding:10px 0px;" />
                    <h5>Deposit</h5>
                    <div class="flex-form contracts-flex-form">
                        <div class="form-group">
                            <label>Security Deposit Amount Held</label>
                            <input class="form-control" type="number" formControlName="secDepositAmountHeld" />
                        </div>
                        <div class="form-group">
                            <label>Security Deposited Date</label>
                            <mat-form-field>
                                <input matInput #ref [matDatepicker]="secDepositeDate" class="form-control" formControlName="secDepositeDate" id="secDepositeDate">
                                <mat-datepicker-toggle matSuffix [for]="secDepositeDate"></mat-datepicker-toggle>
                                <mat-datepicker #secDepositeDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <label>Security Deposit Refund Request Date</label>
                            <mat-form-field>
                                <input matInput #ref [matDatepicker]="refundRequestDate" class="form-control" formControlName="refundRequestDate" id="refundRequestDate">
                                <mat-datepicker-toggle matSuffix [for]="refundRequestDate"></mat-datepicker-toggle>
                                <mat-datepicker #refundRequestDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <hr style="padding:10px 0px;" />
                    <h5>Never Started</h5>
                    <div class="flex-form contracts-flex-form">
                        <div class="form-group">
                            <label>Never Started Reason</label>
                            <select class="form-control" formControlName="neverStartedReason">
                                <option value="0">--Select--</option>
                                <option *ngFor="let item of ref_MemNeverStartedReason" value="{{item.reasonID}}">{{item.reason}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Never Started Date</label>
                            <mat-form-field>
                                <input matInput #ref [matDatepicker]="neverStartDate" class="form-control" formControlName="neverStartDate" id="neverStartDate">
                                <mat-datepicker-toggle matSuffix [for]="neverStartDate"></mat-datepicker-toggle>
                                <mat-datepicker #neverStartDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="form-group" style="flex-basis: 48%;">
                            <label>Never Started Notes</label>
                            <textarea class="form-control" rows="3" formControlName="neverStartedNotes"></textarea>
                        </div>
                    </div>
                    <hr style="padding:10px 0px;" />
                    <h5>Cancellation</h5>
                    <div class="flex-form contracts-flex-form">
                        <div class="form-group">
                            <label>Cancellation Reason</label>
                            <select class="form-control" formControlName="cancellationReason">
                                <option value="0">--Select--</option>
                                <option *ngFor="let item of ref_MemCancellationReason" value="{{item.reasonID}}">{{item.reason}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Cancellation Request Date</label>
                            <mat-form-field>
                                <input matInput #ref [matDatepicker]="canRequestDate" class="form-control" formControlName="canRequestDate" id="canRequestDate">
                                <mat-datepicker-toggle matSuffix [for]="canRequestDate"></mat-datepicker-toggle>
                                <mat-datepicker #canRequestDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="form-group" style="flex-basis: 48%;">
                            <label>Cancellation Notes</label>
                            <textarea class="form-control" rows="3" formControlName="cancellationNotes"></textarea>
                        </div>
                    </div>
                    <div class="flex-form contracts-flex-form">
                        <div class="form-group">
                            <label>Cancellation Last Day of Membership Date</label>
                            <mat-form-field>
                                <input matInput #ref [matDatepicker]="canDateLastDayOfMembership" class="form-control" formControlName="canDateLastDayOfMembership" id="canDateLastDayOfMembership">
                                <mat-datepicker-toggle matSuffix [for]="canDateLastDayOfMembership"></mat-datepicker-toggle>
                                <mat-datepicker #canDateLastDayOfMembership></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <label>Days Remaining In Contract</label>
                            <input readonly class="form-control" formControlName="canDaysRemaining" />
                        </div>
                        <div class="form-group">
                            <label>Cancelled Amount Remaining</label>
                            <input class="form-control" formControlName="canAmountRemaining" />
                        </div>
                    </div>
                    <hr style="padding:10px 0px;" />
                    <h5>Termination</h5>
                    <div class="flex-form contracts-flex-form">
                        <div class="form-group">
                            <label>Termination Reason</label>
                            <select class="form-control" formControlName="terminationReason">
                                <option value="0">--Select--</option>
                                <option *ngFor="let item of ref_MemTerminationReason" value="{{item.reasonID}}">{{item.reason}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Termination Date</label>
                            <mat-form-field>
                                <input matInput #ref [matDatepicker]="terminationDate" class="form-control" formControlName="terminationDate" id="terminationDate">
                                <mat-datepicker-toggle matSuffix [for]="terminationDate"></mat-datepicker-toggle>
                                <mat-datepicker #terminationDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <label>Purchased Vessel Brand</label>
                            <select class="form-control" formControlName="purchasedVesselBrand">
                                <option value="0">--Select--</option>
                                <option *ngFor="let item of ref_MemPurchasedVesselBrand" value="{{item.brandID}}">{{item.brand}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Purchased From Boat</label>
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="purchasedFromBoat" formControlName="purchasedFromBoat">
                                <label class="custom-control-label custom-control-label-disabled" for="purchasedFromBoat"></label>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Trade Reason</label>
                            <select class="form-control" formControlName="tradeReason">
                                <option value="0">--Select--</option>
                                <option *ngFor="let item of ref_MemTradeReason" value="{{item.reasonID}}">{{item.reason}}</option>
                            </select>
                        </div>
                    </div>
                    <hr style="padding:10px 0px;" />
                    <h5>Collections</h5>
                    <div class="flex-form contracts-flex-form">
                        <div class="form-group">
                            <label>Collections Vendor</label>
                            <select class="form-control" formControlName="collectionsVendor">
                                <option value="0">--Select--</option>
                                <option *ngFor="let item of ref_MemCollectionsVendor" value="{{item.vendorID}}">{{item.vendor}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Sent to Collections Date</label>
                            <mat-form-field>
                                <input matInput #ref [matDatepicker]="sentCollectionsDate" class="form-control" formControlName="sentCollectionsDate" id="sentCollectionsDate">
                                <mat-datepicker-toggle matSuffix [for]="sentCollectionsDate"></mat-datepicker-toggle>
                                <mat-datepicker #sentCollectionsDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <label>Collections Received Date</label>
                            <mat-form-field>
                                <input matInput #ref [matDatepicker]="collectionsReceivedDate" class="form-control" formControlName="collectionsReceivedDate" id="collectionsReceivedDate">
                                <mat-datepicker-toggle matSuffix [for]="collectionsReceivedDate"></mat-datepicker-toggle>
                                <mat-datepicker #collectionsReceivedDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <label>Collections Received Amount</label>
                            <input class="form-control" formControlName="collectionsReceivedAmount" />
                        </div>
                    </div>

                    <div>
                        <div class="button-group">
                            <button type="button" (click)="saveUpdateMemberShip()" class="primary-btn">Save</button>
                        </div>
                    </div>
                </div>
            </form>
            <!--<div class="table-panel">
                <div class="">
                    <div class="text-right">
                        <div class="button-group" style="border:none;">
                        </div>
                    </div>
                </div>
                <div class="table-body">

                </div>
            </div>-->
        </div>
    </div>
</div>

<div class="modal fade" id="sendEmail" tabindex="-1" role="dialog" aria-labelledby="sendEmailLabel" aria-hidden="true" data-focus="false">
    <div class="custom-modal-panel" role="document">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content user-body-section border-radius-contact">
                <div class="modal-body">
                    <app-contact-email *ngIf="sendMailInfo?.isShow" [loggedUser]="user" (closeEmailModal)="hideSendMail()" [contactId]="sendMailInfo?.contactId"></app-contact-email>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="sendTextModal" tabindex="-1" role="dialog" aria-labelledby="exampleTextModalLabel" aria-hidden="true" data-focus="false">
    <div class="custom-modal-panel" role="document">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content user-body-section border-radius-contact">
                <div class="modal-body">
                    <app-contact-sms *ngIf="user && selectedContactId > 0" (updatedTextMsg)="hideTextMsgModal($event)" [loggedUser]="user" [contactId]="selectedContactId"></app-contact-sms>
                </div>
            </div>
        </div>
    </div>
</div>
